import CrossIcon from "../../assets/icons/CrossIcon";
import { useAuthModal } from "../../hooks/authContext";
import { login } from "../../store/slice/authSlice";
import { AppDispatch, RootState } from "../../store/store";
import { register } from "./AuthModal.function";
import "./AuthModal.scss";
import React from "react";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

const AuthModal = () => {
  const { isOpen, setIsOpen } = useAuthModal();
  const username = useRef() as React.MutableRefObject<HTMLInputElement>;
  const password = useRef() as React.MutableRefObject<HTMLInputElement>;

  const firstName = useRef() as React.MutableRefObject<HTMLInputElement>;
  const lastName = useRef() as React.MutableRefObject<HTMLInputElement>;
  const email = useRef() as React.MutableRefObject<HTMLInputElement>;
  const companyName = useRef() as React.MutableRefObject<HTMLInputElement>;
  const registerPassword = useRef() as React.MutableRefObject<HTMLInputElement>;
  const [rememberMe, setRememberMe] = useState(false);
  const modalRef = useRef<HTMLDivElement>(null);
  const dispatch = useDispatch<AppDispatch>();
  const { error, isAuthenticated } = useSelector(
    (state: RootState) => state.auth
  );

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen, setIsOpen]);

  const handleLoginSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    dispatch(
      login({
        username: username.current.value,
        password: password.current.value,
        _remember_me: rememberMe,
      })
    );
  };

  const handleRegisterSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    register(
      firstName.current.value,
      lastName.current.value,
      email.current.value,
      companyName.current.value,
      registerPassword.current.value,
      setIsOpen
    );
  };

  useEffect(() => {
    if (isAuthenticated) setIsOpen(false);
  }, [isAuthenticated, setIsOpen]);

  return (
    <React.Fragment>
      {isOpen && (
        <div className="auth-modal-overlay">
          <div id="auth-modal">
            <div className="auth-modal-content" ref={modalRef}>
              {!isAuthenticated && (
                <React.Fragment>
                  <h4 className="auth-title">
                    J’AI DÉJÀ UN COMPTE
                    <CrossIcon onClick={() => setIsOpen(false)} />
                  </h4>
                  <form className="auth-form" onSubmit={handleLoginSubmit}>
                    <input
                      type="text"
                      placeholder="Identifiant ou e-mail*"
                      name="sp-username"
                      autoCapitalize="off"
                      autoCorrect="off"
                      autoComplete="email username"
                      ref={username}
                      required
                    />
                    <input
                      type="password"
                      placeholder="Mot de passe*"
                      name="sp-password"
                      ref={password}
                      required
                    />
                    <div className="auth-options">
                      <label>
                        <input
                          type="checkbox"
                          onChange={() => setRememberMe((rm) => !rm)}
                        />
                        <span>Rester connecté</span>
                      </label>
                      <a href="/reset-password">Mot de passe oublié</a>
                    </div>
                    {error && <p className="error-text">{error}</p>}
                    <button type="submit" className="auth-button">
                      Me connecter
                    </button>
                  </form>
                  <h4 className="auth-title">JE N’AI PAS ENCORE DE COMPTE</h4>
                  <form className="auth-form" onSubmit={handleRegisterSubmit}>
                    <div className="auth-name-fields">
                      <input
                        type="text"
                        placeholder="Prénom"
                        autoCapitalize="off"
                        autoCorrect="off"
                        autoComplete="given-name"
                        name="sp-firstname"
                        ref={firstName}
                        required
                      />
                      <input
                        type="text"
                        placeholder="Nom"
                        autoCapitalize="off"
                        autoCorrect="off"
                        autoComplete="family-name"
                        name="sp-lastname"
                        ref={lastName}
                        required
                      />
                    </div>
                    <input
                      type="text"
                      placeholder="Nom de l’entreprise"
                      autoCapitalize="off"
                      autoCorrect="off"
                      autoComplete="organization"
                      name="sp-company"
                      ref={companyName}
                      required
                    />
                    <input
                      type="email"
                      placeholder="E-mail*"
                      autoCapitalize="off"
                      autoCorrect="off"
                      autoComplete="email"
                      name="sp-email"
                      ref={email}
                      required
                    />
                    <input
                      type="password"
                      placeholder="Mot de passe*"
                      autoCapitalize="off"
                      autoCorrect="off"
                      name="sp-password"
                      ref={registerPassword}
                      minLength={8}
                      required
                    />

                    <button type="submit" className="auth-button">
                      Créer mon compte
                    </button>
                  </form>
                </React.Fragment>
              )}
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default AuthModal;
